import { render, staticRenderFns } from "./NotificationSubscription.vue?vue&type=template&id=1799dc35&"
import script from "./NotificationSubscription.vue?vue&type=script&lang=ts&"
export * from "./NotificationSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationSubscription.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VLayout,VProgressCircular,VSwitch})
